const APP_VERSION_COOKIE_NAME = 'app_version';
const THIRTY_DAYS_IN_SECONDS = 60 * 60 * 24 * 30;

export const getAppVersionCookie = (): string | null => {
  const match = document.cookie.split('; ').find((entry) => entry.startsWith(`${APP_VERSION_COOKIE_NAME}=`));
  return match ? decodeURIComponent(match.slice(APP_VERSION_COOKIE_NAME.length + 1)) : null;
};

export const setAppVersionCookie = (): void => {
  document.cookie = `${APP_VERSION_COOKIE_NAME}=v2; Path=/; Max-Age=${THIRTY_DAYS_IN_SECONDS}; SameSite=Lax; Secure`;
};

export const clearAppVersionCookie = (): void => {
  document.cookie = `${APP_VERSION_COOKIE_NAME}=; Path=/; Max-Age=0`;
};
